import { useMemo } from 'react';
import { useQuery } from '../use-query';

export const useApiParserQuery = () => {
  const [query, setQuery] = useQuery();
  const decodeQuery = Object.keys(query).reduce((pre, curr) => {
    let newValue = query[curr];
    try {
      newValue = JSON.parse(query[curr] as any);
    } catch (ex) {}
    return {
      ...pre,
      [curr]: newValue,
    };
  }, {});

  return useMemo(
    () => ({
      query: decodeQuery,
      setQuery: (data: any) => {
        const encodeQuery = Object.keys(data).reduce(
          (pre, curr) => ({
            ...pre,
            [curr]: typeof data[curr] === 'object' ? JSON.stringify(data[curr]) : data[curr],
          }),
          {},
        );
        setQuery(encodeQuery);
      },
    }),
    [query],
  );
};
